import { useCallback } from "react";
import { clinicianPortalApi } from "../api/clinicianPortalApi";
import { usePortalData } from "./usePortalData";

export function useActivityTemplates(
  clinicianCode: string,
  options: { enabled?: boolean } = {},
) {
  const enabled = options.enabled ?? true;
  const scopeKey = clinicianCode;
  const request = useCallback(
    async (signal: AbortSignal) => ({
      scopeKey,
      response: await clinicianPortalApi.getActivityTemplates(
        clinicianCode,
        signal,
      ),
    }),
    [clinicianCode, scopeKey],
  );
  const state = usePortalData(request, { enabled });
  const data =
    state.status === "success" || state.status === "refreshing"
      ? state.data
      : undefined;
  const response = data?.scopeKey === scopeKey ? data.response : undefined;
  const available = Boolean(
    response?.found && response.authorized && response.therapist,
  );
  const error = !enabled
    ? undefined
    : state.status === "error"
      ? state.error
      : response && !available
        ? new Error("Activity Templates are unavailable")
        : undefined;

  return {
    templates:
      available && response
        ? response.templates.filter((template) => template.status === "On")
        : [],
    isLoading: Boolean(
      enabled &&
        !response &&
        (state.status === "loading" || state.status === "refreshing"),
    ),
    error,
    retry: state.refresh,
  };
}
